module.exports = __webpack_public_path__ + "static/media/Rivadavia.e14b015f.jfif";